import React, { PureComponent } from 'react';
import { Col, Row, Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Auth from '../../shared/Auth';
import { session } from '../../Service/APIService';
import Axios from '../../utils/axiosClient';

class ModalCBChange extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      isLoading: true,
      btnLoading: false,
    };
    this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.fetchCBStatus(this.props.deviceId, this.props.assetToDiSettingId);
  }

  async fetchCBStatus(deviceId, assetToDiSettingId) {
    const urlGetSld = `digiops/cbstatus/${deviceId}/${assetToDiSettingId}`;
    const authStatus = await Auth();
    if (authStatus) {
      await Axios.get(urlGetSld).then(
        (res) => {
          if (res.data.statusCode === 200) {
            this.setState({ data: res.data.result, isLoading: false });
          } else {
            this.props.hide();
            alert(res.data.message);
          }
        },
        (err) => {
          this.setState({ data: [], isLoading: false });
          console.log('Error getting SLD', err);
        }
      );
    }
  }

  async onSubmitButtonClick() {
    const { data } = this.state;
    this.setState({ btnLoading: true });
    const userObj = session.user();
    const isSbo = data?.sbo === 1 || data?.sbo === true;
    const obj = {
      assetId: data.assetId,
      productId: data.productId,
      fromDIStatus: Number(data.currentDIStatus),
      fromDIText: data.currentDIText,
      toDIStatus: Number(data.changeDIStatus),
      toDIText: data.changeDIText,
      scheduledTime: data.reportedDatetime,
      asset2DiSettingId: this.props.assetToDiSettingId,
      directOperate: isSbo ? 0 : 1,
      isSelect: isSbo ? 1 : 0,
      isExecute: isSbo ? 1 : 0,
      createdBy: userObj.username,
    };

    const url = 'digiops';
    const authStatus = await Auth();
    if (authStatus) {
      await Axios.post(url, obj).then(
        (res) => {
          this.setState({ btnLoading: false });
          if (res.data.statusCode === 200) {
            this.props.hide();
            toast.success(res.data.result, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        },
        (err) => {
          this.setState({ btnLoading: false });
          toast.error('Something went wrong', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log('Error getting SLD', err);
        }
      );
    }
  }

  render() {
    const { data, isLoading, btnLoading } = this.state;
    return (
      <Modal show={true} centered onHide={() => this.props.hide()}>
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Would you like to change?</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12} md={12} sm={12}>
              {isLoading ? (
                'Please wait....'
              ) : (
                <div dangerouslySetInnerHTML={{ __html: data.displayMsg }} />
              )}
            </Col>
          </Row>
        </Modal.Body>
        <br />
        <Modal.Footer>
          <div>
            {!isLoading && (
              <Button
                disabled={btnLoading}
                onClick={this.onSubmitButtonClick}
                bsStyle="success"
                bsSize="small"
                style={{ position: 'relative', marginLeft: '1em' }}
              >
                Send Now
              </Button>
            )}
            <Button
              onClick={() => this.props.hide()}
              bsStyle="danger"
              bsSize="small"
              style={{ position: 'relative', marginLeft: '1em' }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ModalCBChange;
